import { useCallback } from 'react';
import * as api from 'app/api';
import { setAuthInfo } from 'app/hook/login/useLogin';
import { ACCESS_TOKEN_KEY } from 'app/libs/auth';
import { Base64 } from 'js-base64';
import useSsrCookie from 'app/hook/common/useSsrCookie';
import { clearAuthInfo } from '../login/useLogout';

function useToken() {
	const { getCookie } = useSsrCookie();

	const renewToken = useCallback(async () => {
		try {
			const { data } = await api.renewToken();
			const { sessionKey, apiKey } = data || {};
			setAuthInfo(sessionKey, apiKey.accessToken);
			return true;
		} catch (err) {
			const { headers = {}, data = {} } = err.response || {};

			// 블랙리스트 회원
			if (data && data.code === '30004') {
				clearAuthInfo();
				const { link } = headers;
				window.location.href = link;
				return false;
			}

			console.error(err);
			alert('토큰 갱신에 실패했습니다.');
			return false;
		}
	}, []);

	const getTokenPayload = useCallback(() => {
		const token = getCookie(ACCESS_TOKEN_KEY);
		const payload = token.split('.')[1];
		return JSON.parse(Base64.decode(payload));
	}, [getCookie]);

	const getTokenExpire = useCallback(() => {
		const payload = getTokenPayload();
		return new Date(payload.exp * 1000);
	}, [getTokenPayload]);

	return { renewToken, getTokenPayload, getTokenExpire };
}

export default useToken;
